import React, { Component } from 'react'

import { slugify } from '@/modern/utils/transformString'

import { OPPORTUNITIES_INFO } from '@/modern/utils/constants'
import SearchBar from '@/modern/components/SearchBar'
import { cleanString } from 'utils/utils'
import PlaceHolder from '../PlaceHolder'
import FilterOrder from '../FilterOrderList'

import './FilterResult.scss'

export default class FilterResult extends Component {
  renderFilterAdvanced() {
    return (
      <div className="FilterResult__options__item">
        <button
          data-qa="filter_show_toggle"
          onClick={this.props.openFilter}
          type="button"
          id="FilterAdvanced"
          className="FilterResult__options__item__button FilterResult__options__item__button--filter-advanced"
        />
      </div>
    )
  }

  createFiltersList() {
    const { listFilters } = this.props
    return [...new Set(listFilters)]
  }

  addNewFilters(list) {
    const { newFilters } = this.props
    const newFiltersArray = Object.entries(newFilters)
    const { superPreco, carDelivery, trocaComTroco, vistoriado } = OPPORTUNITIES_INFO

    const opportunitiesLabels = {
      superPreco: superPreco.displayName,
      carDelivery: carDelivery.displayName,
      trocaComTroco: trocaComTroco.displayName,
      'visão360°': OPPORTUNITIES_INFO['visão360°'].displayName,
      vistoriado: vistoriado.displayName,
    }

    for (let i = 0; i < newFiltersArray.length; i++) {
      const [filterKey, isSelected] = newFiltersArray[i]
      if (isSelected) {
        list.push(opportunitiesLabels[filterKey])
      } else {
        const index = list.indexOf(opportunitiesLabels[filterKey])
        if (index > -1) {
          list.splice(index)
        }
      }
    }
  }

  renderFilterListResult() {
    const list = this.createFiltersList()

    this.addNewFilters(list)

    return (
      <ul id="FilterResultContainer" className="FilterResult__container">
        {list &&
          list.length > 0 &&
          list.map((_item, i) => {
            const isString = typeof _item === 'string'
            const itemName = isString ? _item : _item.join(', ')
            const itemId = slugify(itemName)

            const isEncodedItemName =
              itemName.includes('%') &&
              itemName.toLowerCase() != '100% multimarcas'
            const itemTextLink = isEncodedItemName
              ? decodeURIComponent(itemName)
              : itemName

            const dataQA = `filter_result_${cleanString(itemTextLink, {
              toLowerCase: 1,
              removeAccents: 1,
              removeDots: 1,
              slugify: 1,
            })}`

            return (
              <li key={i} className="FilterResult__container__list">
                <a
                  data-qa={dataQA}
                  rel="noreferrer"
                  id={itemId}
                  className="FilterResult__container__list__item"
                  onClick={() => this.props.closeBalloon(_item)}
                >
                  {itemTextLink || <PlaceHolder />}
                </a>
              </li>
            )
          })}
      </ul>
    )
  }

  render() {
    const {
      compact,
      setCardPreferences,
      cardPreferences,
      renderClickOrderSelected,
      value,
      vehicleType,
      fetchAutoComplete,
      autoCompleteCar,
      autoCompleteBike,
      cookieNoticeContext,
      responsive,
    } = this.props

    const cardClassName =
      cardPreferences === '1' ? ' btn-option--list' : ' btn-option--grid'

    return (
      <div className="FilterResult">
        {!compact && this.renderFilterAdvanced()}
        <div className="FilterResult__scroll">
          <div className="FilterResult__scroll__container">
            {this.renderFilterListResult()}
          </div>
        </div>

        <SearchBar
          fetchAutoComplete={fetchAutoComplete}
          vehicleType={vehicleType}
          autoCompleteCar={autoCompleteCar}
          autoCompleteBike={autoCompleteBike}
          cookieNoticeContext={cookieNoticeContext}
          responsive={responsive}
        />

        {!compact && (
          <div className="FilterResult__options">
            <button
              data-qa="toggle_filter_result_view"
              onClick={setCardPreferences}
              className={`btn-option${cardClassName}`}
            />
            <FilterOrder
              renderClickOrderSelected={renderClickOrderSelected}
              value={value}
              vehicleType={vehicleType}
            />
          </div>
        )}
      </div>
    )
  }
}
